// src/App.js
import React from 'react';
import {HashRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import {createTheme, ThemeProvider} from '@mui/material/styles';

import Login from './pages/Login/Login';

import Solicitacoes from './pages/Solicitacoes/Solicitacoes';
import SolicitacaoServico from './pages/SolicitacaoServico/SolicitacaoServico';
import NotasPagamento from './pages/NotasPagamento/NotasPagamento';
import OrdemServico from './pages/Solicitacoes/Solicitacoes';
import Inicio from './pages/Inicio/Inicio';

import {PopupProvider} from './contexts/PopupContext';
import FornecedorLayout from './components/layout/FornecedorLayout';

const theme = createTheme({
    typography: {
        body1: {
            fontSize: '14px',
            fontWeight: 400,
        },
        subtitle2: {
            fontWeight: 700,
            color: '#0F172A',
            fontSize: '14px',
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                size: 'small',
            },
            styleOverrides: {
                root: {
                    'maxWidth': 500,
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '6px', // ajustado para menos arredondado
                        fontSize: '14px',
                    },
                },
            },
        },
    },
});

export default function App() {
    return (
        <PopupProvider>
            <ThemeProvider theme={theme}>
                <Router>
                    <Routes>
                        {/* raiz redireciona pra login */}
                        <Route path="/" element={<Navigate to="/login" replace />} />

                        {/* tela de login */}
                        <Route path="/login" element={<Login />} />

                        {/* cada rota é embrulhada no layout */}
                        <Route
                            path="/inicio"
                            element={
                                <FornecedorLayout user={{name: 'Fornecedor Nome'}}>
                                    <Inicio />
                                </FornecedorLayout>
                            }
                        />
                        <Route
                            path="/ordem-servico"
                            element={
                                <FornecedorLayout user={{name: 'Fornecedor Nome'}}>
                                    <OrdemServico />
                                </FornecedorLayout>
                            }
                        />
                        <Route
                            path="/solicitacoes"
                            element={
                                <FornecedorLayout user={{name: 'Fornecedor Nome'}}>
                                    <Solicitacoes />
                                </FornecedorLayout>
                            }
                        />
                        <Route
                            path="/solicitacao"
                            element={
                                <FornecedorLayout user={{name: 'Fornecedor Nome'}}>
                                    <SolicitacaoServico />
                                </FornecedorLayout>
                            }
                        />
                        <Route
                            path="/notas-pagamento"
                            element={
                                <FornecedorLayout user={{name: 'Fornecedor Nome'}}>
                                    <NotasPagamento />
                                </FornecedorLayout>
                            }
                        />

                        {/* qualquer outra URL leva pro login */}
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Routes>
                </Router>
            </ThemeProvider>
        </PopupProvider>
    );
}
